"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteUserDateResponse = exports.DeleteUserData = exports.CheckUserProviderAssociation = exports.CreateOrUpdateUserProvider = exports.VerifyLogin = exports.BeginLogin = exports.LoginWithProviderResponse = exports.RefreshAccessTokenDto = exports.UpdatePushTokenDto = exports.UpdateDto = exports.RegisterDto = exports.LoginWithCredentialsDto = void 0;
class LoginWithCredentialsDto {
}
exports.LoginWithCredentialsDto = LoginWithCredentialsDto;
class RegisterDto {
}
exports.RegisterDto = RegisterDto;
class UpdateDto {
}
exports.UpdateDto = UpdateDto;
class UpdatePushTokenDto {
}
exports.UpdatePushTokenDto = UpdatePushTokenDto;
class RefreshAccessTokenDto {
}
exports.RefreshAccessTokenDto = RefreshAccessTokenDto;
class LoginWithProviderResponse {
}
exports.LoginWithProviderResponse = LoginWithProviderResponse;
class BeginLogin {
}
exports.BeginLogin = BeginLogin;
class VerifyLogin {
}
exports.VerifyLogin = VerifyLogin;
class CreateOrUpdateUserProvider {
}
exports.CreateOrUpdateUserProvider = CreateOrUpdateUserProvider;
class CheckUserProviderAssociation {
}
exports.CheckUserProviderAssociation = CheckUserProviderAssociation;
class DeleteUserData {
}
exports.DeleteUserData = DeleteUserData;
class DeleteUserDateResponse {
}
exports.DeleteUserDateResponse = DeleteUserDateResponse;
//# sourceMappingURL=auth.dto.js.map